import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconHistory$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconHistory extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '1736789bba201a0105ea58b3c144e2f971ed1f1e', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '8639e847f58b7bd807bdec8cc56e34bbddd8f6b2', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: 'c52eaffc919986b57c9a5a7c223c7d796f6b5339', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M18.5 11a6.5 6.5 0 0 1-6 6.481.53.53 0 0 0-.5.519v.5c0 .276.225.502.5.485A8 8 0 1 0 4 11v2.316l-2.196.004a.4.4 0 0 0-.29.68l3 3a.4.4 0 0 0 .56 0l3-3a.4.4 0 0 0-.29-.69l-2.284.004V11a6.5 6.5 0 1 1 13 0m-6.25-2.508v2.556l1.59 1.789a.495.495 0 0 1 0 .698l-.38.325a.506.506 0 0 1-.7 0l-1.88-2.095a.45.45 0 0 1-.13-.324v-2.95c0-.27.224-.491.5-.491h.5c.276 0 .5.22.5.492", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-history", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-history"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-history":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconHistory$1);
            }
            break;
    } });
}

const CosmosIconHistory = CosmosIconHistory$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconHistory, defineCustomElement };
